import { css } from 'styled-components';
import { NumberFormatValues } from 'react-number-format';
import { useCallback } from 'react';
import {
  useRfqBuilderActions,
  useRfqBuilderCategorizedLegView,
  useRfqBuilderView,
} from '@paradigm/features/src/unified-rfqs/ui';

import { useSubmitted } from '@paradigm/features/src/forms/submitted-context';
import { useDebouncedTrackAction } from '@paradigm/features/src/analytics';
import { BaseNumericField } from './BaseNumericField';

export default function QuantityField() {
  const { index, quantity, isHedge } = useRfqBuilderCategorizedLegView();
  const { strategy, strategyShortcut } = useRfqBuilderView();
  const { selectLegQuantity } = useRfqBuilderActions();
  const { didSubmit } = useSubmitted();
  const trackAction = useDebouncedTrackAction();

  const strategyCode =
    strategyShortcut.selectedOption?.value ??
    strategy.selectedOption?.value ??
    null;

  const handleOnChange = useCallback(
    ({ value }: NumberFormatValues) => {
      trackAction('update strategy leg', {
        strategyCode,
        quantity: value,
        isHedge,
      });
      if (value !== quantity.value) {
        selectLegQuantity(index, value);
      }
    },
    [
      index,
      isHedge,
      quantity.value,
      selectLegQuantity,
      strategyCode,
      trackAction,
    ],
  );

  return (
    <BaseNumericField
      aria-label="Quantity"
      disabled={quantity.isDisabled}
      placeholder="Enter"
      helperContent={quantity.contractQuantity}
      helperCss={css`
        padding: 0 0.6rem;
        margin: 0;
        line-height: 1;
        opacity: 0.8;
        overflow: hidden;
        white-space: nowrap;
      `}
      value={quantity.value}
      thousandSeparator
      decimalScale={quantity.precision}
      onValueChange={handleOnChange}
      warning={!quantity.isValid && didSubmit}
    />
  );
}
